import { render, staticRenderFns } from "./PostContainer.vue?vue&type=template&id=27823319&"
import script from "./PostContainer.vue?vue&type=script&lang=js&"
export * from "./PostContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PostContainer.vue"
export default component.exports